import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

const propTypes = { infoText: PropTypes.string.isRequired };

const Info = ({ infoText, className }) => {
  const getClassName = () => {
    return classNames('byline --small', className);
  }

  return (
    <p className={getClassName()} data-testid='overdue-note'>{infoText}</p>
  );
}

Info.propTypes = propTypes;
export default Info;



// WEBPACK FOOTER //
// ./src/features/PrincipalPaydown/components/Hero/Info.js